// v2.19.30 — Bloc Module Livreur owner-only dans /mon-compte.
// Affiche le token PRO seedé + 4 liens vers les routes livreur.
import { toast } from "sonner";

const COURIER_TOKEN = "CIV-PRO-OWNER001-DEMO";

const COURIER_LINKS = [
  { href: "/livreur/login",         label: "🔑 Accès livreur",        testId: "courier-link-login" },
  { href: "/livreur/navigate",      label: "🗺️ Navigation course",    testId: "courier-link-navigate" },
  { href: "/livreur/historique",    label: "📊 Historique livraisons", testId: "courier-link-historique" },
  { href: "/livreur/zones-chaudes", label: "🔥 Heatmap zones chaudes", testId: "courier-link-heatmap" },
];

export default function CourierAccessBlock() {
  const copyToken = async () => {
    try {
      await navigator.clipboard.writeText(COURIER_TOKEN);
      toast.success("✅ Token livreur copié");
    } catch (_) {
      toast.error("Copie impossible");
    }
  };

  return (
    <div data-testid="owner-courier-block" style={{
      marginTop: 14, paddingTop: 14, borderTop: "1px dashed rgba(251,191,36,0.35)",
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
        <span style={{ fontSize: 18 }}>🚚</span>
        <h3 style={{ margin: 0, fontSize: 14, color: "#FBBF24", fontWeight: 700 }}>Module Livreur</h3>
      </div>
      <p style={{ margin: "0 0 10px", fontSize: 12, color: "rgba(255,255,255,0.7)", lineHeight: 1.45 }}>
        Accès direct aux outils livreur PRO. Le token ci-dessous est à fournir à tes livreurs
        pour qu'ils se connectent depuis n'importe quel device.
      </p>
      {/* Token + Copier */}
      <div style={{
        display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap",
        padding: "10px 12px", background: "rgba(15,23,42,0.55)",
        border: "1px solid rgba(251,191,36,0.3)", borderRadius: 10, marginBottom: 10,
      }}>
        <code data-testid="courier-token-value" style={{
          fontSize: 12, color: "#FCD34D", fontFamily: "monospace",
          wordBreak: "break-all", flex: 1, minWidth: 0,
        }}>{COURIER_TOKEN}</code>
        <button
          type="button"
          onClick={copyToken}
          data-testid="courier-token-copy"
          style={{
            padding: "6px 12px", background: "rgba(251,191,36,0.22)",
            color: "#FBBF24", border: "1px solid rgba(251,191,36,0.45)",
            borderRadius: 8, cursor: "pointer", fontSize: 12, fontWeight: 700,
            fontFamily: "inherit", whiteSpace: "nowrap",
          }}
        >📋 Copier</button>
      </div>
      {/* Liens */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: 8 }}>
        {COURIER_LINKS.map((l) => (
          <a
            key={l.href}
            href={l.href}
            data-testid={l.testId}
            style={{
              display: "block", textAlign: "center",
              padding: "10px 12px",
              background: "rgba(15,23,42,0.55)",
              border: "1px solid rgba(251,191,36,0.4)",
              borderRadius: 10,
              textDecoration: "none",
              color: "#FBBF24",
              fontWeight: 700,
              fontSize: 13,
            }}
          >{l.label}</a>
        ))}
      </div>
    </div>
  );
}
